import React from 'react';

import Link from '../Link';
import Exempel from '../Information/BehallInneborden';

import Fact from './Fact';

function HoC(props) {
  return (
    <Fact id="behall" title="Behåll innebörden" {...props}>
      <p>
        {`
          När du formulerar ett kostråd får du använda andra formuleringar än
          Livsmedelsverkets men innebörden får inte ändras.
        `}
      </p>

      <Exempel />

      <p>
        <Link to="/faktabank/#vilseledande">
          {'Läs även mer under rubriken Vilseledande.'}
        </Link>
      </p>
    </Fact>
  );
}

export default HoC;



// WEBPACK FOOTER //
// ./src/components/Fact/FactBehallInneborden.js